import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button,
  GeneralMessage,
  useGeneralMessage
} from '../../common/APICommon';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import {
  Input,
} from '../../common/Input';
import { token, domain } from '../Security';
import { LoadingSpinner } from '../../common/Loading';
import { Select } from "../../common/Select"; // ADDED
// icon
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from '@mui/icons-material/Edit';

function VesselType({ user, isHideSideMenu }) {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  var headers = [
    "ID",
    "Code",
    "Vessel Type Name",
    "Vessel Class",       // ADDED
    "Operation Group",    // ADDED
    "Status",
    "Actions"
  ]

  var accessors = [
    "id",
    "code",
    "name",
    "vesselClassDescription",   // ADDED
    "operationGroupCode",       // ADDED
    "isActive",
    "actions"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [vesselClassOptions, setVesselClassOptions] = useState([]);      // ADDED
  const [operationGroupOptions, setOperationGroupOptions] = useState([]); // ADDED

  // Form state
  const [form, setForm] = useState({
    name: "",
    code: "",
    vesselClassId: "",      // ADDED
    operationGroupId: "",   // ADDED
    isActive: true,
  });

  const resetLocalVariables = () => {
    setForm({
      name: "",
      code: "",
      vesselClassId: "",      // ADDED
      operationGroupId: "",   // ADDED
      isActive: true,
    });
    setSelectedData(null);
  }

  // Retrieve
  const [filterData, setFilterData] = useState([]);
  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  // Update
  const [showEditForm, setShowEditForm] = useState(false);

  const apiUrl = domain + "/api/VesselType";
  const vesselClassUrl = domain + "/api/VesselClass";       // ADDED
  const operationGroupUrl = domain + "/api/OperationGroup";      // ADDED

  // ADDED
  const fetchVesselClasses = useCallback(async () => {
    try {
      const response = await axios.get(vesselClassUrl + "/active", {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setVesselClassOptions(response.data.map(d => ({
        value: d.id,
        label: d.description,
      })));
    } catch (error) {
      console.error('Error fetching vessel classes:', error);
    }
  }, [vesselClassUrl]);

  // ADDED
  const fetchOperationGroups = useCallback(async () => {
    try {
      const response = await axios.get(operationGroupUrl + "/active", {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setOperationGroupOptions(response.data.map(d => ({
        value: d.id,
        label: d.code,
      })));
    } catch (error) {
      console.error('Error fetching operation groups:', error);
    }
  }, [operationGroupUrl]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setData(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchVesselClasses();   // ADDED
    fetchOperationGroups(); // ADDED
    fetchData();
  }, [fetchVesselClasses, fetchOperationGroups, fetchData]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();

    if (!value) {
      setData(filterData);
      return;
    }

    const res = filterData.filter((f) => {
      const match1 = f.name?.toString().toLowerCase().includes(lowercaseValue);
      const match2 = f.code?.toString().toLowerCase().includes(lowercaseValue);
      const match3 = f.id?.toString().startsWith(lowercaseValue);
      const match4 = f.vesselClassDescription?.toString().toLowerCase().includes(lowercaseValue);   // ADDED
      const match5 = f.operationGroupCode?.toString().toLowerCase().includes(lowercaseValue);       // ADDED
      return match1 || match2 || match3 || match4 || match5;
    });

    setData(res);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const apiData = {
      name: form.name || "",
      code: form.code || "",
      vesselClassId: form.vesselClassId ? parseInt(form.vesselClassId) : null,      // ADDED
      operationGroupId: form.operationGroupId ? parseInt(form.operationGroupId) : null, // ADDED
      isActive: form.isActive !== undefined ? form.isActive : true,
    };

    console.log('Add Submitting data:', apiData);

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl, apiData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Vessel Type",
        actionTaken: "insert",
        field: "Add",
        newValue: `${apiData.name} (${apiData.code})`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchData();

      showGeneralMessage("Vessel type created successfully!", true);
      closeAddHandleClick();
    } catch (error) {
      console.error('Error creating data:', error.response || error);

      const errorMessage = error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.message ||
        "Failed to create vessel type";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!selectedData?.id) {
      showGeneralMessage("No record selected for update", false);
      return;
    }

    const apiData = {
      name: form.name || "",
      code: form.code || "",
      vesselClassId: form.vesselClassId ? parseInt(form.vesselClassId) : null,          // ADDED
      operationGroupId: form.operationGroupId ? parseInt(form.operationGroupId) : null, // ADDED
      isActive: form.isActive !== undefined ? form.isActive : true,
    };

    try {
      setLoadingRequest(true);
      await axios.put(`${apiUrl}/${selectedData.id}`, apiData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      let auditInfo = [];

      if (apiData.name !== selectedData.name) {
        auditInfo.push({
          setupArea: "Vessel Type",
          actionTaken: "update",
          field: "Name",
          newValue: `${apiData.name}`,
          oldValue: `${selectedData.name}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (apiData.code !== selectedData.code) {
        auditInfo.push({
          setupArea: "Vessel Type",
          actionTaken: "update",
          field: "Code",
          newValue: `${apiData.code}`,
          oldValue: `${selectedData.code}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      // ADDED
      if (apiData.vesselClassId !== selectedData.vesselClassId) {
        const newVC = vesselClassOptions.find(opt => opt.value === apiData.vesselClassId);
        const oldVC = vesselClassOptions.find(opt => opt.value === selectedData.vesselClassId);
        auditInfo.push({
          setupArea: "Vessel Type",
          actionTaken: "update",
          field: "Vessel Class",
          newValue: newVC ? newVC.label : "-",
          oldValue: oldVC ? oldVC.label : "-",
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      // ADDED
      if (apiData.operationGroupId !== selectedData.operationGroupId) {
        const newOG = operationGroupOptions.find(opt => opt.value === apiData.operationGroupId);
        const oldOG = operationGroupOptions.find(opt => opt.value === selectedData.operationGroupId);
        auditInfo.push({
          setupArea: "Vessel Type",
          actionTaken: "update",
          field: "Operation Group",
          newValue: newOG ? newOG.label : "-",
          oldValue: oldOG ? oldOG.label : "-",
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (apiData.isActive !== selectedData.isActive) {
        auditInfo.push({
          setupArea: "Vessel Type",
          actionTaken: "update",
          field: "Is Active?",
          newValue: `${apiData.isActive ? "Active" : "Inactive"}`,
          oldValue: `${selectedData.isActive ? "Active" : "Inactive"}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (auditInfo.length > 0) {
        await SetAuditTrailBulk({ data: auditInfo });
      }

      setShowEditForm(false);
      await fetchData();

      showGeneralMessage("Vessel type updated successfully!", true);
      closeEditHandleClick();
    } catch (error) {
      console.error('Error updating data:', error.response || error);

      const errorMessage = error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.message ||
        "Failed to update vessel type";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const editHandleClick = (data) => {
    setSelectedData(data);

    setForm({
      name: data.name || "",
      code: data.code || "",
      vesselClassId: data.vesselClassId?.toString() || "",       // ADDED
      operationGroupId: data.operationGroupId?.toString() || "", // ADDED
      isActive: data.isActive !== undefined ? data.isActive : true,
    });
    openEditHandleClick();
  };

  const openAddHandleClick = () => {
    setShowAddForm(true);
  };

  const closeAddHandleClick = () => {
    setShowAddForm(false);
    resetLocalVariables();
  };

  const openEditHandleClick = () => {
    setShowEditForm(true);
  };

  const closeEditHandleClick = () => {
    setShowEditForm(false);
    resetLocalVariables();
  };

  const getStatusBadge = (isActive) => {
    return isActive ? (
      <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">Active</span>
    ) : (
      <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800">Inactive</span>
    );
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
  ];

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Maintenance >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Vessel Type"}</span>
              </div>
              <h3>Vessel Type</h3>
            </div>
            <div className='p-4 space-y-4'>
              <SearchBar handleFilter={handleFilter} />

              <Button icon={<AddIcon />}
                name={"Add Vessel Type"}
                className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
                onClick={openAddHandleClick}
              />
              <CreateTable
                tableName={"Vessel Types"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
                customRenderers={{
                  isActive: (value) => getStatusBadge(value)
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <AddEditForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        form={form}
        setForm={setForm}
        handleSubmit={handleSubmit}
        modalName={"Add Vessel Type"}
        mode="add"
        vesselClassOptions={vesselClassOptions}         // ADDED
        operationGroupOptions={operationGroupOptions}   // ADDED
      />
      <AddEditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        form={form}
        setForm={setForm}
        handleSubmit={handleUpdate}
        modalName={"Update Vessel Type"}
        mode="edit"
        vesselClassOptions={vesselClassOptions}         // ADDED
        operationGroupOptions={operationGroupOptions}   // ADDED
      />

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

      <LoadingSpinner loading={loadingRequest || loading} />

    </div>
  )
}

function AddEditForm({
  isOpen,
  modalName,
  onClose,
  form,
  setForm,
  handleSubmit,
  mode = "add",
  vesselClassOptions,       // ADDED
  operationGroupOptions,    // ADDED
}) {
  const [errorState, setErrorState] = useState({
    name: false,
    code: false,
    vesselClassId: false,     // ADDED
    operationGroupId: false,  // ADDED
  });

  const submit = (e) => {
    e.preventDefault();

    // MODIFIED — added vesselClassId and operationGroupId validation
    const newErrorState = {
      name: !form.name,
      code: !form.code,
      vesselClassId: !form.vesselClassId,
      operationGroupId: !form.operationGroupId,
    };

    if (newErrorState.name || newErrorState.code || newErrorState.vesselClassId || newErrorState.operationGroupId) {
      setErrorState(newErrorState);
      return;
    }

    handleSubmit(e);
    setErrorState({ name: false, code: false, vesselClassId: false, operationGroupId: false });
  };

  const handleClose = () => {
    onClose();
    setErrorState({ name: false, code: false, vesselClassId: false, operationGroupId: false });
  };

  const handleInputChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (!isOpen) return null;

  const isEditMode = mode === "edit";

  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
      >
        <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">

          {/* Header */}
          <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
              <span className="text-xl text-gray-600">{modalName}</span>
            </h2>

            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none"
              aria-label="Close modal"
            >
              <CloseIcon fontSize="medium" />
            </button>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto flex-grow space-y-4">

            {/* Vessel Type Form */}
            <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
              <div className="py-1 border-b border-gray-300">
                <h3 className="font-medium text-gray-700">Vessel Type Information</h3>
              </div>
              <div className="grid grid-cols-1 gap-4 pb-3 pt-3">
                <Input
                  label="Code:"
                  value={form.code}
                  onChange={(e) => handleInputChange('code', e.target.value)}
                  placeholder="Enter code"
                  isRequired={true}
                  error={errorState.code && !form.code}
                  errorMessage="Please fill up this field"
                />
                <Input
                  label="Vessel Type Name:"
                  value={form.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  placeholder="Enter vessel type name"
                  isRequired={true}
                  error={errorState.name && !form.name}
                  errorMessage="Please fill up this field"
                />

                {/* ADDED */}
                <Select
                  label="Vessel Class:"
                  value={form.vesselClassId}
                  onChange={(e) => handleInputChange('vesselClassId', e.target.value)}
                  options={vesselClassOptions}
                  placeholder="Select vessel class"
                  isRequired={true}
                  error={errorState.vesselClassId && !form.vesselClassId}
                  errorMessage="Please select a vessel class"
                />

                {/* ADDED */}
                <Select
                  label="Operation Group:"
                  value={form.operationGroupId}
                  onChange={(e) => handleInputChange('operationGroupId', e.target.value)}
                  options={operationGroupOptions}
                  placeholder="Select operation group"
                  isRequired={true}
                  error={errorState.operationGroupId && !form.operationGroupId}
                  errorMessage="Please select an operation group"
                />

                <div className="flex items-center pt-2">
                  <input
                    type="checkbox"
                    checked={form.isActive !== undefined ? form.isActive : true}
                    onChange={(e) => handleInputChange('isActive', e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label className="ml-2 text-sm font-medium text-gray-600">
                    Active
                  </label>
                </div>
              </div>
            </div>

          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-2 p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
            <button
              onClick={handleClose}
              className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
            >
              Cancel
            </button>

            <button
              onClick={submit}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
            >
              {isEditMode ? "Update" : "Save"}
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default VesselType